import React from 'react';
import { Link } from 'react-router-dom';
// Did not use Link
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import projectContent from './data/research-content'
import NavDropdownResearch from './components/NavDropdownResearch'

const NavBar = () => (
    <Navbar className='navColor' collapseOnSelect expand="lg" variant="dark">
    <Navbar.Brand as={Link} to="/#home">Lei Lab</Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav " />
    <Navbar.Collapse id="responsive-navbar-nav ">
      <Nav className="m-auto justify-content-center">
        
      </Nav>
      <Nav>
        <Nav.Link as={Link} to="/">Home</Nav.Link>
        <Nav.Link as={Link} to="/people">People</Nav.Link>
        <NavDropdown title="Research" id="collasible-nav-dropdown">
            <NavDropdownResearch articles={projectContent}/>
          {/* <NavDropdown.Divider /> */}
        </NavDropdown>
        <Nav.Link as={Link} to="/facilities">Facilities</Nav.Link>
        <Nav.Link as={Link} to="/publications">Publications</Nav.Link>
        <Nav.Link as={Link} to="/news">News</Nav.Link>
        <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);



export default NavBar;